/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { CURRENT_TCAS_YEAR, CURRENT_TCAS_LABEL } from 'constants/school-year';
import { formatThaiDeadline, formatThaiCancelUpdatedDate } from 'helpers';
import enabled from 'data/enabled.json';

const ModalOfferCancelConsent = ({ visible, onSubmit }) => {
  if (!visible) return null;
  return (
    <div className="t-modal" style={{ visibility: 'visible', opacity: 1, pointerEvents: 'auto' }}>
      <div
        className="content"
        style={{ padding: '20px 30px', opacity: 1, height: 'initial', overflow: 'auto', textAlign: 'left' }}
      >
        <h1>ข้อกำหนดและเงื่อนไขในการสละสิทธิ์</h1>
        <p className="text-center">
          กรุณาอ่านรายละเอียดให้ครบถ้วน และคลิกปุ่ม <strong>"รับทราบ"</strong> ในส่วนล่างสุด
        </p>
        <br />
        <h2>การสละสิทธิ์</h2>
        <p>
          ผู้สมัครต้องดำเนินการสละสิทธิ์ให้แล้วเสร็จภายในวันเวลาที่กำหนด สามารถเลือกดำเนินการได้ 1 ครั้งจาก 3
          ช่วงเวลาเพื่อสมัครรอบต่อไปได้คือ
        </p>
        <div className='color-orange'>
          <p>
            <b>
              {/* ช่วงที่ 1 = cancel window เดิมของรอบ 1 (มี.ค.) — derive จาก enabled.round1.cancel_end ไม่ได้
                  เพราะ key นั้นถูก realign เป็นค่า พ.ค. ตาม runbooks/round-switching → ต้องแก้มือตอนตั้งปฏิทินปีใหม่ */}
              <u>ช่วงที่ 1</u> สามารถดำเนินการได้ภายในเวลา 23.59 น. ของวันที่ 12 มีนาคม {CURRENT_TCAS_YEAR} เพื่อสมัครรอบ 2 หรือรอบ 3
              หรือรอบ 4

            </b>
          </p>
          <p>
            <b>
              <u>ช่วงที่ 2</u> สามารถดำเนินการได้ภายในวันที่ {formatThaiDeadline(enabled.round2.cancel_end)} เพื่อสมัครรอบ 3 หรือรอบ 4
            </b>
          </p>
          <p>
            <b>
              <u>ช่วงที่ 3</u> สามารถดำเนินการได้ภายในวันที่ {formatThaiDeadline(enabled.round3.cancel_end)} เฉพาะผู้ที่ยืนยันสิทธิ์รอบ 3 Admission และไม่เคยสละสิทธิ์มาก่อนเท่านั้น
            </b>
          </p>
        </div>
        <p>
          <b>หมายเหตุ : หากสละสิทธิ์ครั้งที่ 2 จะไม่สามารถเข้าสู่กระบวนการสมัครและคัดเลือกในรอบต่อไปได้</b>
        </p>
        <p>โดย</p>
        <ol>
          <li>การสละสิทธิ์ต้องดำเนินการในระบบ {CURRENT_TCAS_LABEL} เท่านั้น และขอยกเลิกการสละสิทธิ์ในภายหลังไม่ได้</li>
          <li>
            การแจ้งสละสิทธิ์ที่มหาวิทยาลัย โดยไม่ดำเนินการกดปุ่ม “สละสิทธิ์” ในระบบ {CURRENT_TCAS_LABEL} ตามเวลาที่กำหนด
            ไม่ถือเป็นการสละสิทธิ์ในระบบ {CURRENT_TCAS_LABEL} ซึ่งจะไม่สามารถสมัครคัดเลือกในรอบต่อไปได้
          </li>
        </ol>

        <div className="text-right">
          <small>
            <em>ปรับปรุงล่าสุดเมื่อวันที่ {formatThaiCancelUpdatedDate(enabled.round1.cancel_end)}</em>
          </small>
        </div>
        <hr />

        <div className="action">
          <a className="btn-main cursor-pointer" onClick={onSubmit}>
            {'รับทราบ'}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ModalOfferCancelConsent;
